import { useRef } from 'react';
import * as THREE from 'three';
import { useState } from 'react';

export let map;

// Scaling factor for shapes
export let shape_scaling_factor = "";

// Speed of animation
export let animate_speed = 300;

// Loading timer count
export let loading_timer_count = 0;

// Object for storing color mappings
export let colorMap = {};

// Three.js object for storing individual shape meshes
export let fmesh = new THREE.Object3D();

export let fmeshPoints = new THREE.Object3D();

// Three.js object for storing all shape meshes
export let fullmesh = new THREE.Object3D();

// Variable for storing the currently found feature
export let foundFeature;
export const setFoundFeature = (newFeature) => {
  foundFeature = newFeature;
};

// Variable for storing the currently found feature initial depth
export let foundFeatureInitDepths = {};
export const setFoundFeatureInitDepth = (skylark_id, newDepth) => {
  foundFeatureInitDepths[skylark_id] = newDepth;
};

// Variable for storing the currently found feature new depth
export let foundFeatureNewDepth = null;
export const setFoundFeatureNewDepth = (newDepth) => {
  foundFeatureNewDepth = newDepth;
};

// IF PUSHING TO DEV

// export const apiBaseUrl = 'https://api.dev.harrier.land';

// IF PUSHING TO STAGING

export const apiBaseUrl = 'https://api.staging.harrier.land';

export const mapPalette = [
  "#8F7AAE", // muted purple
  "#A694C1", // soft violet
  "#9B8F7A", // warm taupe
  "#BDAA84", // sand
  "#A47548", // ochre brown
  "#6F8FA8", // slate blue
  "#6FA1A3", // muted teal
  "#4F6F8F", // deep blue
  "#6F7F4F", // olive
  "#4F6B57", // forest green
  "#8A6F55", // clay
  "#C08A45", // muted amber
  "#9A6A45", // burnt earth
  "#8F8EBA", // dusty blue-lavender
  "#7E7464", // stone
  "#7D8CA3", // steel blue
  "#8B9B6B", // sage olive
  "#A88C6D", // tan
  "#7A6A91", // dusky violet
  "#5F7F7C", // weathered teal
  "#9C7C8F", // mauve
  "#6C7A5B", // moss
  "#B39A73", // dry grass
  "#6A5F7A", // smoky purple
  "#7B8F8D", // sea mist
  "#A27A62", // terracotta
  "#5E6E86", // muted navy
  "#8D846A", // khaki stone
  "#738A6E", // eucalyptus
  "#AA8F9E", // dusty rose
];

export function useGlobalRefs() {
  const mapRef = useRef(null);
  const drawRef = useRef(null);
  const centroidRef = useRef(null);
  const clickedInfoRef = useRef(null);
  const dropdownListRef = useRef(null);
  const polygonCustomLayerRef = useRef(null);
  const longstandingGeoJSONRef = useRef(null);
  const originalGeoJSONforComparingRef = useRef(null);
  const mapContainerRef = useRef(null);
  const loadedDataGeojson = useRef(null);
  const mapboxTokenRef = useRef(process.env.REACT_APP_MAPBOX_TOKEN);
  const piechartRef = useRef(null);
  const extendedpiechartRef = useRef(null);
  const TotalsRef = useRef(null);
  const CompareRef = useRef(null);
  const PDFpiechartRef = useRef(null);
  const PDFTotalsRef = useRef(null);
  const PDFCompareRef = useRef(null);
  const PDFParcelInfoRef = useRef(null);
  const pendingBoundaryChangesRef = useRef([]);
  let currentMapIdRef = useRef(null);
  const selectedFirstPrivateMapParentRef = useRef(null);
  const toastRef = useRef(null);
  const baseMapIDRefForRefWhenUsingOriginalLayer = useRef(null);

  return {
    mapRef,
    drawRef,
    centroidRef,
    clickedInfoRef,
    dropdownListRef,
    polygonCustomLayerRef,
    longstandingGeoJSONRef,
    mapContainerRef,
    loadedDataGeojson,
    originalGeoJSONforComparingRef,
    mapboxTokenRef,
    piechartRef,
    extendedpiechartRef,
    TotalsRef,
    CompareRef,
    PDFpiechartRef,
    PDFTotalsRef,
    PDFCompareRef,
    PDFParcelInfoRef,
    pendingBoundaryChangesRef,
    currentMapIdRef,
    selectedFirstPrivateMapParentRef,
    toastRef,
    baseMapIDRefForRefWhenUsingOriginalLayer
  };
}

export function useGlobalFileStates() {
  const [isFilenameInputOpen, setIsFilenameInputOpen] = useState(false);
  const [newFilename, setNewFilename] = useState('');
  const [newFileScreenShot, setNewFileScreenShot] = useState('');
  const [loadedFileName, setloadedFileName] = useState('Base Data');

  return {
    isFilenameInputOpen,
    setIsFilenameInputOpen,
    newFilename,
    setNewFilename,
    newFileScreenShot,
    setNewFileScreenShot,
    loadedFileName,
    setloadedFileName,
  };
}

export function useGlobalState() {

  const [debugMode, setDebugMode] = useState(false);

  const [workingLocally, setWorkingLocally] = useState(false);

  // IF PUSHING TO DEV OR STAGING

  const [devDeployment, setDevDeployment] = useState(false);

  const [clickedInfo, setClickedInfo] = useState(null);
  const [clickedInfoHeader, setClickedInfoHeader] = useState(null);
  const [clickedInfoHeaderMobile, setClickedInfoHeaderMobile] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isDrawing, setisDrawing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [filenames, setFilenames] = useState([]);
  const [isMenuLoadClick, setisMenuLoadClick] = useState(false);
  const [isHasSaved, setisHasSaved] = useState(false);
  const [isHasSavedCurrentData, setisHasSavedCurrentData] = useState(false);
  const [openAuth, setopenAuth] = useState(false);
  const [isSelectingLandtypes, setisSelectingLandtypes] = useState(false);
  const [isLeftDrawerOpen, setisLeftDrawerOpen] = useState(true);
  const [isLeftSubDrawerOpen, setisLeftSubDrawerOpen] = useState(false);
  const [selectedLandTypes, setSelectedLandTypes] = useState([]);
  const [PiechatSelectionCancelOnClick, setPiechatSelectionCancelOnClick] = useState(false);
  const [isViewingPieChart, setisViewingPieChart] = useState(false);
  const [isViewingForecast, setisViewingForecast] = useState(false);
  const [isModifying, setisModifying] = useState(false);
  const [isComparing, setisComparing] = useState(false);
  const [isInSettings, setIsInSettings] = useState(false);
  const [isInAboutPanel, setIsInAboutPanel] = useState(false);
  const [isInPrivacyPanel, setIsInPrivacyPanel] = useState(false);
  const [isInTacPanel, setIsInTacPanel] = useState(false);
  const [isInInvestorsPanel, setIsInInvestorsPanel] = useState(false);
  const [dropdownhighlightedIndex, setdropdownhighlightedIndex] = useState(null);
  const [is2DViewActive, setIs2DViewActive] = useState(false);
  const [uniqueTextureNamesArray, setUniqueTextureNamesArray] = useState([]);
  const [storedfeaturecurrentlandtype, setStoredFeatureCurrentLandtype] = useState('');
  const [mapbearing, setMapBearing] = useState(0);
  const [isLanduse, setIsLanduse] = useState(false);
  const [isViewingLargePieChart, setisViewingLargePieChart] = useState(false);
  const [comparingLandtypeSelectedOption, setcomparingLandtypeSelectedOption] = useState('');
  const [isDraggableSubDrawerOpen, setisDraggableSubDrawerOpen] = useState(false);
  const [selectedYearEditing, setSelectedYearEditing] = useState('');
  const [selectedRange, setSelectedRange] = useState([null, null]);
  const [selectedAggregate, setSelectedAggregate] = useState("");
  const [isCtrlDown, setIsCtrlDown] = useState(false);
  const [loadedAmount, setLoadedAmount] = useState(0);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [isControlsNavOpen, setIsControlsNavOpen] = useState(false);
  const [mapSavedWithFilenameSuccess, setMapSavedWithFilenameSuccess] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState('');
  const [finishedEditing, setFinishedEditing] = useState(false);
  const [hasCreatedNewPolygonInModify, setHasCreatedNewPolygonInModify] = useState('');
  const [loadedPercentage, setLoadedPercentage] = useState(0);
  const [temporaryGeoJSONIntendedForSaving, setTemporaryGeoJSONIntendedForSaving] = useState([]);
  const [currentMapId, setCurrentMapId] = useState(null);
  const [loggedInToAPI, setLoggedInToAPI] = useState(false);
  const [adminUser, setAdminUser] = useState(false);
  const [acknowledgeNewFaetureNewDepth, setAcknowledgeNewFaetureNewDepth] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [convertingData, setConvertingData] = useState(false);
  const [isViewingConvertedData, setIsViewingConvertedData] = useState(false);
  const [universalParcelDifferentiator, setUniversalParcelDifferentiator] = useState('');
  const [universalColorPaletteName, setUniversalColorPaletteName] = useState('');
  const [isCreateAccountPopupVisible, setIsCreateAccountPopupVisible] = useState(false);
  const [globalPublicSelectedDataset, setGlobalPublicSelectedDataset] = useState('UnitedKingdom');
  const [universalDataLoaded, setUniversalDataLoaded] = useState(false);
  const [hasChangedKeyValue, setHasChangedKeyValue] = useState('');
  const [globalPolygonTransparency, setGlobalPolygonTransparency] = useState(1);
  const [isResetLandDataConfirmationModalOpen, setIsResetLandDataConfirmationModalOpen] = useState(false);
  const [storeEditedBoundaryFeatureSkylarkID, setStoreEditedBoundaryFeatureSkylarkID] = useState('');
  const [multiLayerSelected, setMultiLayerSelected] = useState('false');
  const [multuLayerSelectedArray, setMultuLayerSelectedArray] = useState([]);
  const [greoupingSelected, setGreoupingSelected] = useState(false);
  const [multuGroupSelectedArray, setMultuGroupSelectedArray] = useState([]);
  const [SMSelectedArray, setSMSelectedArray] = useState([]);
  const [scenarioModelledFeatureIds, setScenarioModelledFeatureIds] = useState([]);
  const [scenarioModels, setScenarioModels] = useState([]);
  const [scenarioHighlightedFeatureIds, setScenarioHighlightedFeatureIds] = useState([]);
  const [scenarioModelledViewEnabled, setScenarioModelledViewEnabled] = useState(false);
  const [scenarioModelingModeActive, setScenarioModelingModeActive] = useState(false);
  const [isCreatingPDF, setIsCreatingPDF] = useState(false);
  const [clickedMapId, setClickedMapId] = useState(null);
  const [clickedMapIDtoLoad, setClickedMapIDtoLoad] = useState(null);
  const [availableKeys, setAvailableKeys] = useState(null);
  const [availableIDs, setAvailableIDs] = useState(null);
  const [availableValues, setAvailableValues] = useState(null)
  const [selectedKey, setSelectedKey] = useState('');
  const [compareSelectedKey, setCompareSelectedKey] = useState('');
  const [landKeySelectedKey, setLandKeySelectedKey] = useState('');
  const [isGroupOrMultiLayerTabSelected, setIsGroupOrMultiLayerTabSelected] = useState('');
  const [activeLayer, setActiveLayer] = useState(1);
  const [hiddenLayer, setHiddenLayer] = useState([0]);
  const [IsLoadingNewGeoJSONFromAnUpdate, setIsLoadingNewGeoJSONFromAnUpdate] = useState(false);
  const [APIReportMessage, setAPIReportMessage] = useState('')
  const [recentChangeList, setRecentChangeList] = useState([]);
  const [yearsAvailable, setYearsAvailable] = useState([]);
  const [isRighdivrawerVisible, setIsRighdivrawerVisible] = useState(true);
  const [activeTab, setActiveTab] = useState("GROUP");
  const [isWorkingWithinRealm, setIsWorkingWithinRealm] = useState(false);
  const [isRealmLeftClickedInfoVisible, setIsRealmLeftClickedInfoVisible] = useState(false);
  const [globalStateMapDistanceKm, setGlobalStateMapDistanceKm] = useState(null);
  const [mapMetaData, setMapMetaData] = useState(null);
  const [mapOverview, setMapOverview] = useState(null);
  const [featureList, setFeatureList] = useState([]);
  const [activeFeatureId, setActiveFeatureId] = useState(null);
  const [isYearRangeOpen, setIsYearRangeOpen] = useState(false);
  const [selectionLoadVersion, setSelectionLoadVersion] = useState(0);
  const [noKeysAvailableFromData, setNoKeysAvailableFromData] = useState(false);
  const [noValuesAvailableFromData, setNoValuesAvailableFromData] = useState(false);
  const [layers, setLayers] = useState([
    { number: 1, active: 'active', key: 'default', value: 'default' }
  ]);
  const [numericSummary, setNumericSummary] = useState(null);
  const [keySummary, setKeySummary] = useState(null);
  const [globalNumericSummaryAggregateToTriggerSliderWithNewAggregate, setGlobalNumericSummaryAggregateToTriggerSliderWithNewAggregate] = useState('');
  const [globalStartDate, setGlobalStartDate] = useState("");
  const [globalEndDate, setGlobalEndDate] = useState("");
  const [selectionNonce, setSelectionNonce] = useState(0);
  const [dataHasNoKeys, setDataHasNoKeys] = useState('');
  const [dataHasNoValues, setDataHasNoValues] = useState('');
  const [activeLayerStringFromLayerIdForSummarising, setActiveLayerStringFromLayerIdForSummarising] = useState("");
  const [showFilterFeatureDataSimpleTimeseriesModal, setShowFilterFeatureDataSimpleTimeseriesModal] = useState('');
  const [showFilterFeatureDataSimpleModal, setShowFilterFeatureDataSimpleModal] = useState('');

  const [relativitySliderAmount, setRelativitySliderAmount] = useState(1);

  const [availableDates, setAvailableDates] = useState([]);

  const [userID, setUserID] = useState('');

  const [availableNumericMetrics, setAvailableNumericMetrics] = useState([]);
  const [availableStringMetrics, setAvailableStringMetrics] = useState([]);

  const [clickedInfoTab, setClickedInfoTab] = useState("DATA");

  const [userIsMapOwner, setUserIsMapOwner] = useState(null);

  const [numericTimeAggregationMethod, setNumericTimeAggregationMethod] = useState('year');

  const [initialDataLoadComplete, setInitialDataLoadComplete] = useState('');

  const [LOADINGPARAM_startOfLoad, setLOADINGPARAM_startOfLoad] = useState(false);
  const [LOADINGPARAM_makeScene, setLOADINGPARAM_makeScene] = useState(false);
  const [LOADINGPARAM_initAnimation, setLOADINGPARAM_initAnimation] = useState(false);
  const [LOADINGPARAM_onAdd, setLOADINGPARAM_onAdd] = useState(false);
  const [LOADINGPARAM_createShapes, setLOADINGPARAM_createShapes] = useState(false);
  const [LOADINGPARAM_applyDateRange, setLOADINGPARAM_applyDateRange] = useState(false);
  const [LOADINGPARAM_resetMapAfterDatesReceived, setLOADINGPARAM_resetMapAfterDatesReceived] = useState(false);
  const [LOADINGPARAM_fetchKeyData, setLOADINGPARAM_fetchKeyData] = useState(false);
  const [LOADINGPARAM_fetchNumericData, setLOADINGPARAM_fetchNumericData] = useState(false);

  const [geoJSONReadyVersion, setGeoJSONReadyVersion] = useState(0);

  const [singleFeatureEditMode, setSingleFeatureEditMode] = useState(false);

  return {
    userID,
    setUserID,
    clickedInfo,
    setClickedInfo,
    isVisible,
    setIsVisible,
    isDrawing,
    setisDrawing,
    isLoading,
    setIsLoading,
    filenames,
    setFilenames,
    isMenuLoadClick,
    setisMenuLoadClick,
    isHasSaved,
    setisHasSaved,
    isHasSavedCurrentData,
    setisHasSavedCurrentData,
    openAuth,
    setopenAuth,
    isSelectingLandtypes,
    setisSelectingLandtypes,
    isLeftDrawerOpen,
    setisLeftDrawerOpen,
    isLeftSubDrawerOpen,
    setisLeftSubDrawerOpen,
    selectedLandTypes,
    setSelectedLandTypes,
    selectedMetric,
    setSelectedMetric,
    PiechatSelectionCancelOnClick,
    setPiechatSelectionCancelOnClick,
    isViewingPieChart,
    setisViewingPieChart,
    isViewingForecast,
    setisViewingForecast,
    selectedYearEditing,
    setSelectedYearEditing,
    isModifying,
    setisModifying,
    isComparing,
    setisComparing,
    hasCreatedNewPolygonInModify,
    setHasCreatedNewPolygonInModify,
    isInSettings,
    setIsInSettings,
    isInAboutPanel,
    setIsInAboutPanel,
    isInPrivacyPanel,
    setIsInPrivacyPanel,
    isInTacPanel,
    setIsInTacPanel,
    isInInvestorsPanel,
    setIsInInvestorsPanel,
    dropdownhighlightedIndex,
    setdropdownhighlightedIndex,
    is2DViewActive,
    setIs2DViewActive,
    uniqueTextureNamesArray,
    setUniqueTextureNamesArray,
    storedfeaturecurrentlandtype,
    setStoredFeatureCurrentLandtype,
    mapbearing,
    setMapBearing,
    isLanduse,
    setIsLanduse,
    isViewingLargePieChart,
    setisViewingLargePieChart,
    comparingLandtypeSelectedOption,
    setcomparingLandtypeSelectedOption,
    isDraggableSubDrawerOpen,
    setisDraggableSubDrawerOpen,
    clickedInfoHeader,
    setClickedInfoHeader,
    clickedInfoHeaderMobile,
    setClickedInfoHeaderMobile,
    loadedPercentage,
    setLoadedPercentage,
    isCtrlDown,
    setIsCtrlDown,
    loadedAmount,
    setLoadedAmount,
    mapLoaded,
    setMapLoaded,
    temporaryGeoJSONIntendedForSaving,
    setTemporaryGeoJSONIntendedForSaving,
    currentMapId,
    setCurrentMapId,
    loggedInToAPI,
    setLoggedInToAPI,
    isControlsNavOpen,
    setIsControlsNavOpen,
    acknowledgeNewFaetureNewDepth,
    setAcknowledgeNewFaetureNewDepth,
    mapSavedWithFilenameSuccess,
    setMapSavedWithFilenameSuccess,
    workingLocally,
    setWorkingLocally,
    userEmail,
    setUserEmail,
    finishedEditing,
    setFinishedEditing,
    convertingData,
    setConvertingData,
    isViewingConvertedData,
    setIsViewingConvertedData,
    universalParcelDifferentiator,
    setUniversalParcelDifferentiator,
    universalColorPaletteName,
    setUniversalColorPaletteName,
    adminUser,
    setAdminUser,
    isCreateAccountPopupVisible,
    setIsCreateAccountPopupVisible,
    globalPublicSelectedDataset,
    setGlobalPublicSelectedDataset,
    hasChangedKeyValue,
    setHasChangedKeyValue,
    compareSelectedKey,
    setCompareSelectedKey,
    landKeySelectedKey,
    setLandKeySelectedKey,
    universalDataLoaded,
    setUniversalDataLoaded,
    globalPolygonTransparency,
    setGlobalPolygonTransparency,
    isResetLandDataConfirmationModalOpen,
    setIsResetLandDataConfirmationModalOpen,
    storeEditedBoundaryFeatureSkylarkID,
    setStoreEditedBoundaryFeatureSkylarkID,
    layers,
    setLayers,
    activeLayer,
    setActiveLayer,
    hiddenLayer,
    setHiddenLayer,
    multiLayerSelected,
    setMultiLayerSelected,
    multuLayerSelectedArray,
    setMultuLayerSelectedArray,
    greoupingSelected,
    setGreoupingSelected,
    multuGroupSelectedArray,
    setMultuGroupSelectedArray,
    SMSelectedArray,
    setSMSelectedArray,
    scenarioModelledFeatureIds,
    setScenarioModelledFeatureIds,
    scenarioModels,
    setScenarioModels,
    scenarioHighlightedFeatureIds,
    setScenarioHighlightedFeatureIds,
    scenarioModelledViewEnabled,
    setScenarioModelledViewEnabled,
    scenarioModelingModeActive,
    setScenarioModelingModeActive,
    isCreatingPDF,
    setIsCreatingPDF,
    clickedMapId,
    setClickedMapId,
    clickedMapIDtoLoad,
    setClickedMapIDtoLoad,
    availableKeys,
    setAvailableKeys,
    availableValues,
    setAvailableValues,
    selectedKey,
    setSelectedKey,
    isGroupOrMultiLayerTabSelected,
    setIsGroupOrMultiLayerTabSelected,
    IsLoadingNewGeoJSONFromAnUpdate,
    setIsLoadingNewGeoJSONFromAnUpdate,
    APIReportMessage,
    setAPIReportMessage,
    recentChangeList,
    setRecentChangeList,
    yearsAvailable,
    setYearsAvailable,
    isRighdivrawerVisible,
    setIsRighdivrawerVisible,
    activeTab,
    setActiveTab,
    isWorkingWithinRealm,
    setIsWorkingWithinRealm,
    globalStateMapDistanceKm,
    setGlobalStateMapDistanceKm,
    isRealmLeftClickedInfoVisible,
    setIsRealmLeftClickedInfoVisible,
    mapMetaData,
    setMapMetaData,
    devDeployment,
    setDevDeployment,
    featureList,
    setFeatureList,
    activeFeatureId,
    setActiveFeatureId,
    selectedRange,
    setSelectedRange,
    selectedAggregate,
    setSelectedAggregate,
    isYearRangeOpen,
    setIsYearRangeOpen,
    mapOverview,
    setMapOverview,
    selectionLoadVersion,
    setSelectionLoadVersion,
    noKeysAvailableFromData,
    setNoKeysAvailableFromData,
    noValuesAvailableFromData,
    setNoValuesAvailableFromData,
    numericSummary,
    setNumericSummary,
    keySummary,
    setKeySummary,
    globalNumericSummaryAggregateToTriggerSliderWithNewAggregate,
    setGlobalNumericSummaryAggregateToTriggerSliderWithNewAggregate,
    globalStartDate,
    setGlobalStartDate,
    globalEndDate,
    setGlobalEndDate,
    selectionNonce,
    setSelectionNonce,
    dataHasNoKeys,
    setDataHasNoKeys,
    dataHasNoValues,
    setDataHasNoValues,
    activeLayerStringFromLayerIdForSummarising,
    setActiveLayerStringFromLayerIdForSummarising,
    showFilterFeatureDataSimpleTimeseriesModal,
    setShowFilterFeatureDataSimpleTimeseriesModal,
    showFilterFeatureDataSimpleModal,
    setShowFilterFeatureDataSimpleModal,
    relativitySliderAmount,
    setRelativitySliderAmount,
    availableDates,
    setAvailableDates,
    availableNumericMetrics,
    setAvailableNumericMetrics,
    availableStringMetrics,
    setAvailableStringMetrics,
    debugMode,
    setDebugMode,
    availableIDs,
    setAvailableIDs,
    clickedInfoTab,
    setClickedInfoTab,
    userIsMapOwner,
    setUserIsMapOwner,
    numericTimeAggregationMethod,
    setNumericTimeAggregationMethod,
    initialDataLoadComplete,
    setInitialDataLoadComplete,
    LOADINGPARAM_startOfLoad,
    setLOADINGPARAM_startOfLoad,
    LOADINGPARAM_makeScene,
    setLOADINGPARAM_makeScene,
    LOADINGPARAM_initAnimation,
    setLOADINGPARAM_initAnimation,
    LOADINGPARAM_onAdd,
    setLOADINGPARAM_onAdd,
    LOADINGPARAM_createShapes,
    setLOADINGPARAM_createShapes,
    LOADINGPARAM_applyDateRange,
    setLOADINGPARAM_applyDateRange,
    LOADINGPARAM_resetMapAfterDatesReceived,
    setLOADINGPARAM_resetMapAfterDatesReceived,
    LOADINGPARAM_fetchKeyData,
    setLOADINGPARAM_fetchKeyData,
    LOADINGPARAM_fetchNumericData,
    setLOADINGPARAM_fetchNumericData,
    geoJSONReadyVersion,
    setGeoJSONReadyVersion,
    singleFeatureEditMode,
    setSingleFeatureEditMode
  };
}
